import { Pipe, PipeTransform } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { FieldDefinition, FieldDefinitionTranslation } from '@stylehaven/components';
import { DottedKey } from '../entities/metadata-field.entity';

@Pipe({
    standalone: false,
    name: 'translateFieldDefinition',
    pure: true
})
export class TranslateFieldDefinitionPipe implements PipeTransform {
    constructor(private readonly translateService: TranslateService) {}

    private readonly FORCE_LONG_TRANSLATION: string[] = [
        DottedKey.DocumentPublicityRegimen,
        DottedKey.DossierPublicityRegimen
    ];

    transform(fieldDefinition: FieldDefinition, ...args: string[]): any {
        if (!fieldDefinition) {
            return 'UNKNOWN';
        }
        const currentLangTranslation: string | undefined = this.getTranslation(
            fieldDefinition,
            this.translateService.currentLang
        );

        if (currentLangTranslation) {
            return currentLangTranslation;
        }

        const defaultLangTranslation: string | undefined = this.getTranslation(
            fieldDefinition,
            this.translateService.defaultLang
        );

        return defaultLangTranslation ? defaultLangTranslation : fieldDefinition.Key;
    }

    private getTranslation(fieldDefinition: FieldDefinition, lang: string): string | undefined {
        if (this.FORCE_LONG_TRANSLATION.includes(fieldDefinition.DottedKey)) {
            return fieldDefinition.LongTranslations[lang as keyof FieldDefinitionTranslation];
        }
        return fieldDefinition.Translations[lang as keyof FieldDefinitionTranslation];
    }
}
